module.exports = __webpack_public_path__ + "static/1-1-8b05f3494d21442e521e275f73b5f939.png";